// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memoryId: __t.u64().primaryKey().name("memory_id"),
  versonaId: __t.u64().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  factKey: __t.string().name("fact_key"),
  text: __t.string(),
  importance: __t.u32(),
  at: __t.timestamp(),
});
